import React from 'react';
import { RevealSection } from './shared';
import PartnersCarousel from '@/components/PartnersCarousel';

export const PartnersSection = ({ sid, theme, partners }) => (
  <section id={sid} className="py-16 bg-gradient-to-b from-white to-slate-50 border-y border-slate-100">
    <RevealSection>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="text-sm font-bold uppercase tracking-widest mb-2" style={{ color: theme.primary_color }}>Naši partneři</p>
          <h3 className="text-2xl sm:text-3xl font-bold text-slate-900" style={{ fontFamily: `${theme.font_heading}, sans-serif` }}>Spolupracujeme s předními výrobci</h3>
          <p className="text-slate-500 text-sm mt-2 max-w-lg mx-auto">Používáme pouze ověřené komponenty od světových výrobců pro maximální kvalitu a životnost.</p>
        </div>
        <PartnersCarousel partners={partners} />
      </div>
    </RevealSection>
  </section>
);
